import { render, staticRenderFns } from "./AnaliseDocumentacao.vue?vue&type=template&id=24fb3271&scoped=true"
import script from "./AnaliseDocumentacao.vue?vue&type=script&lang=js"
export * from "./AnaliseDocumentacao.vue?vue&type=script&lang=js"
import style0 from "./AnaliseDocumentacao.vue?vue&type=style&index=0&id=24fb3271&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fb3271",
  null
  
)

export default component.exports